import React from 'react'
import { useStyles } from './styles'
import { concatStyles } from 'src/utils'

interface CustomTextAreaProps {
  label?: string
  error?: string
  className?: string
  placeholder?: string
  onPressEnter?: Function
  onChange?: Function
  onBlur?: Function
  register?: Function
  type?: string
  value?: string | number
  disabled?: boolean
  id?: string
  maxLength?: number
  max?: string
  min?: string
  oninput?: string
  style?: any
  onClick?: Function
  autoComplete?: any
  readOnly?: boolean
  rows?: number // Adiciona a propriedade rows para o textarea
  cols?: number // Adiciona a propriedade cols para o textarea
}

export const TextArea: React.FC<CustomTextAreaProps> = ({
  label,
  error,
  className,
  onPressEnter,
  onChange,
  autoComplete,
  register,
  id,
  rows = 4, // Define um valor padrão para rows
  cols = 50, // Define um valor padrão para cols
  ...rest
}) => {
  const { customInputWrapper } = useStyles()

  const handlePress = ({ key }: React.KeyboardEvent) => {
    if (key === 'Enter' && onPressEnter) onPressEnter()
  }
  const handleChange = ({ currentTarget }: React.FormEvent<HTMLInputElement>) => {
    if (onChange) onChange(currentTarget.value)
  }

  const inputOnlyNumber = (event: any) => {
    if (rest?.type === 'number') {
      if (event.key === '+' || event.key === '-') {
        event.preventDefault()
      }
    }
  }

  return (
    <div className={concatStyles(customInputWrapper, className)}>
      <label htmlFor={id || ''} className='custom-input__label'>
        {label}
      </label>
      <textarea
        id={id || ''}
        autoComplete={autoComplete}
        className='custom-input__input'
        onKeyPress={handlePress}
        onChange={handleChange}
        onKeyDown={inputOnlyNumber}
        rows={rows} // Define a quantidade de linhas do textarea
        cols={cols} // Define a quantidade de colunas do textarea
        {...(register && register())}
        {...rest}
      />
      {error && <span className='custom-input__error'>{error}</span>}
    </div>
  )
}
